export default __webpack_public_path__ + "static/media/ep_03.bc034f76.png";